import { Component, OnInit, AfterViewInit, ChangeDetectorRef, ViewChild } from "@angular/core";
import {
    ProductCategories,
    ProductBody,
    ProductAttributes,
    SpecificationData,
    SpecificationsLabel,
} from "@models/product.model";
import { ActivatedRoute, Router } from "@angular/router";
import { ReviewStatus } from "@models/admin.model";
import { ProductService } from "../services/product/product.service";
import { CartItemService } from "../services/cart-item/cart-item.service";
import { BaseCart, CartAttributes, RemoveCartItem } from "@models/cart.model";
import { LocalStorageService } from "../services/local-storage/local-storage.service";
import { RightNavbarComponent } from "../dashboard/right-navbar/right-navbar.component";
import { MatDialog } from "@angular/material/dialog";
import { ShapeJson } from "../shared/models/shape-selector.model";
import { WishlistService } from "../services/wishlistService/wishlist.service";
// import { MatSnackBar } from "@angular/material/snack-bar";
// import { CouponAttributes, CouponsMessage } from "@models/coupon.model";
// import { CouponService } from "../services/coupon/coupon.service";
import { ChoiceType, ErrorMessage, faceDetails, faceLabel } from "../shared/models/helper.model";
import { v4 as uuidv4 } from "uuid";
import { combineLatest, debounceTime, finalize, Subject, take } from "rxjs";
import { MeshType, ShapeInfo } from "../../utils/shape-type";
// import { SnackBarConfig } from "../constants/snackbar.constants";
import { StructureService } from "../services/structure/structure.service";
import { DialogService } from "../services/dialog/dialog.service";
import { DialogInvokingComponents } from "@models/generic-dialog.model";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "../services/auth/auth.service";
import { GenericDialogComponent } from "../shared/generic-dialog/generic-dialog.component";
import * as THREE from "three";
import { BaseReview, ReviewAttributes } from "@models/review.model";
import { Location } from "@angular/common";
import { ColorsPicker } from "~/src/utils/color-constants";
import { ModelQuantityJson } from "@models/structure.model";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackBarConfig } from "../constants/snackbar.constants";
import { UserService } from "../services/user/user.service";

interface FaceColorType {
    [face: string]: string;
}

@Component({
    selector: "app-product-detail-page",
    templateUrl: "./product-detail-page.component.html",
    styleUrls: ["./product-detail-page.component.scss"],
    standalone: false,
})
export class ProductDetailPageComponent implements OnInit, AfterViewInit {
    @ViewChild(RightNavbarComponent) rightNavbarComponent!: RightNavbarComponent;

    public productId!: number;
    public quantity = 1;
    public imageObject: {
        image: string;
        thumbImage: string;
        video?: string;
    }[] = [];
    public productDetail!: ProductAttributes;
    public showAnotherIcon: boolean = false;
    public sliderImageSize = { width: "100%", height: "730px" };
    public data: ProductBody[] = [];
    public cartItems: CartAttributes[] = [];
    public isProductInCart!: boolean;
    public visibleReviews: number = 5;
    public isFullDescription = false;
    public imageObjectReviewAndRating: Array<{ image: string; thumbImage: string }> = [];
    public isDescriptionMoreThanThreeLines = true;
    public showReadMore = false;
    public imageSize = { width: "100px", height: 100 };
    public activeIndex: number = 0;
    public suggestedProducts: ProductAttributes[] = [];
    public currentImageIndex: { [key: number]: number } = {};
    public shapeJson!: ShapeJson;
    public isNavbarOpen: boolean = false;
    public isCategoryBuyBlock: boolean = true;
    private categories = ProductCategories;
    public selectedColor!: THREE.ColorRepresentation;
    public colors = ColorsPicker;
    public SpecificationsLabel = SpecificationsLabel;
    public ratingProducts!: ReviewAttributes[];
    // public activeCouponCodes!: object;
    // public activeCoupons!: CouponAttributes[];
    public selectedOption = faceDetails;
    public cartUUID!: string;
    public infoShape!: ShapeInfo;
    public resetSelectedOption = {
        front: "Plane",
        back: "Plane",
        left: "Plane",
        right: "Plane",
        top: "Plane",
        bottom: "Plane",
    };
    public loading: boolean = true;

    public faceColor!: FaceColorType;
    public faceColorNames: FaceColorType = {};
    public specifications = SpecificationData;
    public isLoading = false;
    public deliveryDate!: Date;
    public pinCode: string = "110001";
    public distributionEntries: any;
    public distribution: any;

    private cartUpdateSubject = new Subject<{ productId: number; quantity: number; cartUUID: string }>();

    constructor(
        private productService: ProductService,
        private route: ActivatedRoute,
        private cartService: CartItemService,
        private router: Router,
        private localStorageService: LocalStorageService,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        private wishListItemService: WishlistService,
        private snackBar: MatSnackBar,
        // private couponService: CouponService,
        private structureService: StructureService,
        private dialogService: DialogService,
        private translate: TranslateService,
        public authService: AuthService,
        public location: Location,
        private userService: UserService,
    ) {}

    ngOnInit(): void {
        // fetching pincode if user is not login
        if (!this.authService.isUserLoggedIn) {
            navigator.geolocation.getCurrentPosition((position) => {
                const lat = position.coords.latitude;
                const lon = position.coords.longitude;
                this.productService.getPincodeforGuestUser(lat, lon).subscribe((pincode) => {
                    this.pinCode = pincode;
                });
            });
            //  fetching the pincode if user is logged In
        } else {
            this.userService.getUserDetails().subscribe((response) => {
                response?.addresses?.forEach((address) => {
                    if (address.isDefault) {
                        this.pinCode = address.pincode.toString();
                    }
                });
            });
        }
        const today = new Date();
        this.deliveryDate = new Date(today);
        this.deliveryDate.setDate(today.getDate() + 7);
        combineLatest([this.cartService.getCartItems(), this.route.params]).subscribe(([items, params]) => {
            if (items) {
                this.cartItems = items;
            }

            this.productId = +params["id"];

            if (this.productId) {
                this.loadProducts();
            }
        });

        this.cartService.cartItemDeleted.subscribe((deletedProductIds: number[]) => {
            if (deletedProductIds.includes(this.productId)) {
                this.isProductInCart = false;
            }
        });

        this.cartUpdateSubject
            .pipe(
                debounceTime(250), // Adjust the time as needed
            )
            .subscribe(({ productId, quantity, cartUUID }) => {
                this.updateCartQuantity(productId, quantity, cartUUID);
            });
    }

    private loadProducts(): void {
        this.loading = true;
        this.productService
            .getProductById(this.productId, true)
            .pipe(
                finalize(() => {
                    this.loading = false;
                }),
            )
            .subscribe((product) => {
                if (!product) {
                    return;
                }

                this.productDetail = product;
                if (
                    this.productDetail.modelQuantityJson &&
                    !this.productDetail.category.includes(ProductCategories.BuyBlocks)
                )
                    this.structureService
                        .fetchStructureData(this.productDetail.modelQuantityJson.modelInfoUrl)
                        .subscribe((response: ModelQuantityJson) => {
                            this.infoShape = this.productService.calculateShapeInfo(response);
                        });
                // this.activeCouponCodes = product.coupon!;
                // if (this.activeCouponCodes) {
                //     this.loadAvailableCouponDetailsblo(this.activeCouponCodes);
                // }
                this.ratingProducts = this.productDetail.reviews?.filter(
                    (review: BaseReview) => review.status === ReviewStatus.Approved && review.review !== "",
                )!;

                this.loadReviewDistribution();

                if (this.productDetail.model3DJson) {
                    this.shapeJson = this.productDetail.model3DJson as ShapeJson;
                }
                this.isCategoryBuyBlock = !!this.productDetail.category?.includes(this.categories.BuyBlocks);

                // Remove 'Number of Shape' specification if the category is Buy Block
                this.specifications = this.specifications.filter(
                    (specification) =>
                        !(
                            specification.label === SpecificationsLabel.NumberOfShape &&
                            (!this.productDetail?.modelQuantityJson || this.isCategoryBuyBlock)
                        ),
                );

                this.isProductInCart = this.cartItems.some((item) => item.product?.id === this.productDetail.id);

                this.quantity = this.isCategoryBuyBlock
                    ? 1
                    : this.localStorageService.getCartedQuantity(this.productId) || 1;

                this.loadImagesAndVideos();
                this.fetchSuggestedProducts(this.productDetail?.subCategory!, this.productDetail?.id);
            });
    }

    ngAfterViewInit() {
        this.checkDescriptionLines();
    }

    public loadReviewDistribution(): void {
        this.productService.getReviewsDistribution(this.productId).subscribe((response) => {
            this.distribution = response;
            this.distributionEntries = Object.entries(this.distribution).sort((a, b) => Number(b[0]) - Number(a[0]));
        });
    }

    public goToHome(): void {
        this.router.navigate(["/"]);
    }

    public goToCart(): void {
        this.router.navigate(["/cart"]);
    }

    private checkDescriptionLines(): void {
        const el = document.querySelector(".description") as HTMLElement;
        if (el) {
            const { lineHeight, borderTop, borderBottom } = window.getComputedStyle(el);
            const contentHeight = el.scrollHeight - parseInt(borderTop) - parseInt(borderBottom);
            const lines = Math.floor(contentHeight / parseInt(lineHeight));

            this.isDescriptionMoreThanThreeLines = lines > 3;
        }
    }

    // public loadAvailableCouponDetails(activeCouponCodes: object): void {
    //     this.couponService.getAvailableCouponDetails(activeCouponCodes).subscribe({
    //         next: (response) => {
    //             this.activeCoupons = response.filter((data) =>
    //                 Object.values(data.discountType).find((type) => type !== "Users"),
    //             );
    //         },
    //         error: (error) => {
    //             throw error.error;
    //         },
    //     });
    // }

    private loadImagesAndVideos(): void {
        if (this.productDetail && this.productDetail.images) {
            const imagesArray = this.productDetail.images.imagesUrl || [];
            let videoUrls: string[] = [];

            if (typeof this.productDetail.video === "string") {
                try {
                    videoUrls = JSON.parse(this.productDetail.video) as string[];
                } catch (e) {
                    videoUrls = [];
                }
            } else if (Array.isArray(this.productDetail.video)) {
                videoUrls = this.productDetail.video;
            }

            this.imageObject = imagesArray.map((imageUrl) => ({
                image: imageUrl,
                thumbImage: imageUrl,
            }));

            if (Array.isArray(videoUrls)) {
                videoUrls.forEach((videoUrl) => {
                    if (typeof videoUrl === "string" && videoUrl) {
                        const fileExtension = videoUrl.split(".").pop()?.toLowerCase();

                        if (fileExtension === "mp4") {
                            this.imageObject.push({
                                image: videoUrl,
                                thumbImage: videoUrl,
                                video: videoUrl,
                            });
                        } else {
                            throw new Error(`Unsupported video format: ${fileExtension}`);
                        }
                    }
                });
            }
        }

        for (let i = 0; i < this.data.length; i++) {
            this.data.forEach((item) => {
                if (item.id === this.productDetail.id) {
                    this.productDetail.disable = true;
                    this.productDetail.quantity = item.quantity;
                } else {
                    this.productDetail.disable = false;
                }
            });
        }
        this.cdr.detectChanges();
    }

    public isOverflow(element: HTMLElement): boolean {
        return element.clientWidth < element.scrollWidth || element.clientHeight < element.scrollHeight;
    }

    public onInputChange(event: Event, item: ProductAttributes): void {
        let inputValueString = (event.target as HTMLInputElement).value;
        const numericalValue = parseInt(inputValueString, 10);
        if (!inputValueString) {
            return;
        }
        if (numericalValue < 1) {
            (event.target as HTMLInputElement).value = "1";
        } else {
            inputValueString = inputValueString.slice(0, 2);
            (event.target as HTMLInputElement).value = inputValueString;
            this.quantity = parseInt(inputValueString, 10);
        }
        this.cartUpdateSubject.next({ productId: item.id, quantity: this.quantity, cartUUID: this.cartUUID! });
    }

    public checkQuantity(item: ProductBody): void {
        if (!this.quantity) {
            this.quantity = 1;
            this.cartUpdateSubject.next({ productId: item.id!, quantity: this.quantity, cartUUID: this.cartUUID });
        }
    }

    public onClick(value: number): void {
        this.quantity += value;
        if (this.isProductInCart) {
            if (!this.isCategoryBuyBlock) {
                this.cartUpdateSubject.next({
                    productId: this.productId,
                    quantity: this.quantity,
                    cartUUID: this.cartUUID,
                });
            }
        }
    }

    private removeSpaceFromShapeType(shapeType: string): string {
        return shapeType.replace(" ", "");
    }

    public addToCart(): void {
        const shapeType = this.removeSpaceFromShapeType(this.productDetail.name) as MeshType;
        const body: CartAttributes = {
            productID: this.productDetail.id,
            quantity: this.quantity,
            cartUUID: uuidv4(),
            ...(this.isCategoryBuyBlock // use for only single block
                ? {
                      singleBlockInfo: {
                          color:
                              Object.keys(this.faceColorNames).length === 0
                                  ? this.defaultFaceColor(shapeType)
                                  : this.faceColorNames,
                          ...this.getFacesForShape(shapeType, this.selectedOption),
                      },
                  }
                : {}),
        };
        this.cartService.addToCart(body, this.productDetail).subscribe((response) => {
            if (response) {
                this.isProductInCart = true;
                this.openSnackBar(response, SnackBarConfig.Actions.OKAY);
                this.resetSelectedOption = {
                    front: "Plane",
                    back: "Plane",
                    left: "Plane",
                    right: "Plane",
                    top: "Plane",
                    bottom: "Plane",
                };
                this.cartUUID = "";
                this.quantity = 1;
            }
        });
    }

    private defaultFaceColor(shapeType: MeshType): { [key: string]: string } {
        const defaultColor = "Dark Green";
        switch (shapeType) {
            case MeshType.Cone:
                return {
                    Bottom: defaultColor,
                    Curved: defaultColor,
                };
            case MeshType.Cube:
                return {
                    Top: defaultColor,
                    Left: defaultColor,
                    Right: defaultColor,
                    Back: defaultColor,
                    Bottom: defaultColor,
                    Front: defaultColor,
                };
            case MeshType.CurvedCube:
                return {
                    Back: defaultColor,
                    Curved: defaultColor,
                    Bottom: defaultColor,
                    Left: defaultColor,
                    Right: defaultColor,
                };
            case MeshType.HalfCylinder:
                return {
                    Left: defaultColor,
                    Curved: defaultColor,
                    Bottom: defaultColor,
                    Right: defaultColor,
                };
            case MeshType.HemiSphere:
                return {
                    Bottom: defaultColor,
                    Curved: defaultColor,
                };
            case MeshType.Cylinder:
                return {
                    Top: defaultColor,
                    Bottom: defaultColor,
                    Curved: defaultColor,
                };
            case MeshType.SquarePyramid:
                return {
                    Bottom: defaultColor,
                    Left: defaultColor,
                    Right: defaultColor,
                    Back: defaultColor,
                    Front: defaultColor,
                };
            case MeshType.Prism:
                return {
                    Bottom: defaultColor,
                    Left: defaultColor,
                    Right: defaultColor,
                    Back: defaultColor,
                    Front: defaultColor,
                };
            case MeshType.RightTriangle:
                return {
                    Bottom: defaultColor,
                    Left: defaultColor,
                    Right: defaultColor,
                    Back: defaultColor,
                    Front: defaultColor,
                };
            // case MeshType.ConcavePrism:
            //     return {
            //         Bottom: defaultColor,
            //         Left: defaultColor,
            //         Right: defaultColor,
            //         Back: defaultColor,
            //         Curved: defaultColor,
            //     };
            case MeshType.CurvedCube2:
                return {
                    Back: defaultColor,
                    Front: defaultColor,
                    Bottom: defaultColor,
                    Curved: defaultColor,
                };
            default:
                throw new Error(`${ErrorMessage.UnknownShapeType}: ${shapeType}`);
        }
    }

    private getFacesForShape(shapeType: MeshType, selectedOption: { [key in faceLabel]: ChoiceType }) {
        switch (shapeType) {
            case MeshType.Cone:
                return {
                    bottom: selectedOption.bottom,
                };
            case MeshType.Cube:
                return {
                    top: selectedOption.top,
                    left: selectedOption.left,
                    right: selectedOption.right,
                    back: selectedOption.back,
                    bottom: selectedOption.bottom,
                    front: selectedOption.front,
                };
            case MeshType.CurvedCube:
                return {
                    back: selectedOption.back,
                    left: selectedOption.left,
                    right: selectedOption.right,
                    bottom: selectedOption.bottom,
                };
            case MeshType.HalfCylinder:
                return {
                    left: selectedOption.left,
                    right: selectedOption.right,
                    bottom: selectedOption.bottom,
                };
            case MeshType.HemiSphere:
                return {
                    bottom: selectedOption.bottom,
                };
            case MeshType.Cylinder:
                return {
                    top: selectedOption.top,
                    bottom: selectedOption.bottom,
                };
            case MeshType.SquarePyramid:
                return {
                    bottom: selectedOption.bottom,
                };
            case MeshType.Prism:
                return {
                    Left: selectedOption.left,
                    Right: selectedOption.right,
                    bottom: selectedOption.bottom,
                };
            case MeshType.RightTriangle:
                return {
                    left: selectedOption.left,
                    right: selectedOption.right,
                    back: selectedOption.back,
                    bottom: selectedOption.bottom,
                };
            // case MeshType.ConcavePrism:
            //     return {
            //         back: selectedOption.back,
            //         bottom: selectedOption.bottom,
            //         left: selectedOption.left,
            //         right: selectedOption.right,
            //     };
            case MeshType.CurvedCube2:
                return {
                    back: selectedOption.back,
                    front: selectedOption.front,
                    bottom: selectedOption.bottom,
                };
            default:
                throw new Error(`${ErrorMessage.UnknownShapeType}: ${shapeType}`);
        }
    }

    public onClickBuy(id: number, quantity: number, product: ProductAttributes): void {
        const shapeType = this.removeSpaceFromShapeType(product.name) as MeshType;
        const existingItem = this.cartService.itemsCart.find(
            (item) => item.product?.id === id || item.productID === id,
        );
        console.log("existingItem", existingItem);
        let body: CartAttributes = {
            productID: id,
            quantity: existingItem ? existingItem?.quantity! + quantity : quantity,
            cartUUID: uuidv4(),
            product,
            ...(this.isCategoryBuyBlock // use for only single block
                ? {
                      singleBlockInfo: {
                          color:
                              Object.keys(this.faceColorNames).length === 0
                                  ? this.defaultFaceColor(shapeType)
                                  : this.faceColorNames,
                          ...this.getFacesForShape(shapeType, this.selectedOption),
                      },
                  }
                : {}),
        };
        this.router
            .navigate(["address"], {
                state: { productData: [body] },
            })
            .then(() => {
                if (existingItem) {
                    this.cartService
                        .updateCartQuantity(id, existingItem?.quantity! + 1, existingItem.cartUUID, undefined)
                        .subscribe();
                } else {
                    this.cartService.addToCart(body, this.productDetail).subscribe((response) => {
                        if (response) {
                            this.isProductInCart = true;
                            this.openSnackBar(response, SnackBarConfig.Actions.OKAY);
                            this.resetSelectedOption = {
                                front: "Plane",
                                back: "Plane",
                                left: "Plane",
                                right: "Plane",
                                top: "Plane",
                                bottom: "Plane",
                            };
                            this.cartUUID = "";
                            this.quantity = 1;
                        }
                    });
                }
            });
    }

    public getTotalRatingsAndReviews(): { validReviewsCount: number; ratingCount: number } {
        let validReviewsCount = 0;
        let ratingCount = 0;

        this.productDetail.reviews?.forEach((review: BaseReview) => {
            if (review.status === ReviewStatus.Approved) {
                if (review.rating !== null) {
                    ratingCount++;
                }
                if (review.review) {
                    validReviewsCount++;
                }
            }
        });

        return {
            validReviewsCount: validReviewsCount,
            ratingCount: ratingCount,
        };
    }

    public getRatingClass(rating: number): string {
        return `rating-${rating}`;
    }

    private fetchSuggestedProducts(subCategory: string, productId: number): void {
        this.productService.suggestedProduct(subCategory!, productId).subscribe({
            next: (response) => {
                this.suggestedProducts = response;
            },
        });
    }

    public onClickProduct(productId: number): void {
        this.router.navigate([`products/${productId}`]);
    }

    public getProductQtyInCart(productId: number, cartUUID?: string): number {
        return this.localStorageService.getCartedQuantity(productId, cartUUID);
    }

    public onclick(value: number, productId: number): void {
        const quantityInCart = this.getProductQtyInCart(productId, this.cartUUID);
        const newQuantity = quantityInCart + value;
        this.cartUpdateSubject.next({ productId, quantity: newQuantity, cartUUID: this.cartUUID });
        if (!this.isNavbarOpen) {
            this.isNavbarOpen = true;
        }
    }

    private updateCartQuantity(productId: number, quantity: number, cartUUID?: string): void {
        if (quantity < 1) {
            this.removeProductFromCart(productId, cartUUID!);
        } else if (quantity <= 99) {
            this.updateProductQuantityInCart(productId, quantity, cartUUID!);
        }
    }

    private removeProductFromCart(productId: number, cartUUID: string): void {
        const item: RemoveCartItem = { productId, cartUUID };
        this.cartService.removeCartItem([item]).subscribe();
    }

    private updateProductQuantityInCart(productId: number, quantity: number, cartUUID: string): void {
        this.cartService.updateCartQuantity(productId, quantity, cartUUID).subscribe();
    }

    public onBlur(event: Event, productId: number): void {
        const inputValue = (event.target as HTMLInputElement).value.trim();
        if (!inputValue) {
            (event.target as HTMLInputElement).value = "1";
            const quantity = parseInt((event.target as HTMLInputElement).value, 10);
            this.cartUpdateSubject.next({ productId, quantity, cartUUID: this.cartUUID });
        }
    }

    public addToCartSuggested(product: ProductAttributes, quantity: number) {
        const item: CartAttributes = {
            productID: product.id,
            quantity: quantity,
            cartUUID: uuidv4(),
        };
        this.cartService.addToCart(item, product).subscribe((response) => {
            if (response) {
                this.openSnackBar(response, SnackBarConfig.Actions.OKAY);
                this.isNavbarOpen = true;
            }
        });
    }

    public onCloseNavbar() {
        this.isNavbarOpen = false;
    }

    public openReviewImages(reviewData: BaseReview): void {
        const imagesArray = reviewData.images?.imagesUrl;
        this.imageObject = imagesArray?.map((imageUrl) => ({
            image: imageUrl,
            thumbImage: imageUrl,
        }))!;

        this.dialog.open(GenericDialogComponent, {
            data: { imageSlider: this.imageObject, componentName: DialogInvokingComponents.ImageSlider },
        });
    }

    public getSelectedColor(color: string): void {
        this.selectedColor = color as THREE.ColorRepresentation;
    }

    public getSeletedChoice(data: { [key in faceLabel]: ChoiceType }): void {
        this.selectedOption = data;
    }

    public getFaceColors(data: { [key: string]: string }): void {
        this.faceColor = data;
        // Map the faceColor values to their corresponding color names
        for (const face in this.faceColor) {
            const colorValue = `#${this.faceColor[face].toUpperCase()}`;
            const color = ColorsPicker.find((c) => c.value.toUpperCase() === colorValue);
            this.faceColorNames[face] = color ? color.name : "Unknown Color";
        }
    }

    public toggleFavorite(product: ProductAttributes): void {
        if (this.authService.isUserLoggedIn) {
            if (this.isInWishlist(product)) {
                this.wishListItemService.deleteFromMyWishlist(product.id).subscribe();
            } else {
                this.wishListItemService.addToWishList([product.id]).subscribe();
            }
        } else {
            this.dialogService.loginDialog();
        }
    }

    public isInWishlist(product: ProductAttributes): boolean {
        if (!this.authService.isUserLoggedIn || !this.wishListItemService.getAllwishlistIDs) {
            return false;
        }

        return this.wishListItemService.getAllwishlistIDs.productIDs.includes(product.id);
    }

    private openSnackBar(message: string, action: string): void {
        this.snackBar.open(message, action, {
            ...SnackBarConfig.Defaults,
        });
    }

    // public copyToClipboard(couponCode: string) {
    //     navigator.clipboard.writeText(couponCode).then(() => {
    //         this.openSnackBar(CouponsMessage.Copied, SnackBarConfig.Actions.OKAY);
    //     });
    // }

    public goToStructure(): void {
        if (!this.productDetail?.id) {
            return;
        }
        this.structureService
            .getStructureByProductId(this.productDetail.id)
            .pipe(take(1))
            .subscribe((response) => {
                if (response?.id) {
                    this.router.navigate([`/designer/${response.id}`], { queryParams: { fromProductDetail: true } });
                }
            });
    }

    public viewShapeCount(): void {
        const dialogData = {
            componentName: DialogInvokingComponents.ProductDetailPage,
            title: this.getTranslation("genericDialogBox.viewCount.title"),
            options: this.infoShape.filteredShapeArray,
            value: this.infoShape.totalBlock,
        };
        this.dialogService
            .openDialog(dialogData, "90%", { disableClose: false }, "896px")
            .afterClosed()
            .subscribe({
                next: (res) => {
                    if (res) {
                        this.goToStructure();
                    }
                },
            });
    }

    private getTranslation(key: string, params?: object): string {
        return this.translate.instant(key, params);
    }

    public goBack(): void {
        this.location.back();
    }

    public isCategoryBuyBlocks(category?: string[] | undefined): boolean {
        return Array.isArray(category) && category.includes(ProductCategories.BuyBlocks);
    }

    public setNavbarOpen(isOpen: boolean): void {
        this.isNavbarOpen = isOpen;
    }

    public isReviewGreaterThan1(ratingProducts: ReviewAttributes[]): boolean {
        return ratingProducts.some((ratingProduct) => ratingProduct.review);
    }

    public getStars(rating: number): string[] {
        const stars: string[] = [];

        const fullStars = Math.floor(rating);
        const hasDecimal = rating % 1 !== 0;

        for (let i = 1; i <= 5; i++) {
            if (i <= fullStars) {
                stars.push("full");
            } else if (i === fullStars + 1 && hasDecimal) {
                stars.push("half");
            } else {
                stars.push("empty");
            }
        }

        return stars;
    }
}
